import { OfferClient } from './offer-client.model';
import { HealthQuestionnaire } from './health-questionnaire.model';
import { FATCAQuestionnaire } from './fatca-questionnaire.model';
import { SPNFTQuestionnaire } from './spnft-questionnaire.model';
import { PLATIMATICQuestionnaire } from './platimatik-questionnaire.model';
import { Beneficiaries } from './beneficiaries.model';
import { RedemptionAndCapitalizations } from './redemption-capitalization-model';
import { OfferInsuree } from './offer-insuree.model';

export class StandardOSOffer {
    constructor(public data?: {
        ID?: Number,
        InsuranceStart?: String,
        InsuranceEnd?: String,
        OfferNumber?: String,
        OfferType?: Number,
        ProductType?: Number,
        ContractorID?: Number,
        InsureeID?: Number,
        Contractor?: OfferClient,
        Insuree?: OfferInsuree,
        ContractorIsInsuree?: Boolean,
        OccupationID?: Number,
        HazardLevel?: Number,
        Gender?: String,
        CigarettesPerDay?: Number,
        Height?: Number,
        Weight?: Number,
        AdditionalInsuranceDeath?: Boolean,
        PaymentPeriodOut?: Number,
        PaymentPeriodIn?: Number,
        StartingAge?: Number,
        Duration?: Number,
        PremiumRate?: Number,
        SumInsured?: Number,
        DeathByAccident?: Number,
        InvalidityByAccident?: Number,
        AdditionalPremiumRateDeath?: Number,
        AdditionalInsuredSumDeath?: Number,
        AdditionalILSumInsured?: Number,
        AdditionalILPremiumRate?: Number,
        AdditionalBFSumInsured?: Number,
        AdditionalBFPremiumRate?: Number,
        AdditionalASPremiumRate?: Number,

        AdditionalRiderDeath?: Number,
        AdditionalRiderTBType?: Number,
        AdditionalRiderTB?: Number,

        DailyFee?: Number,
        TreatmentExpenses?: Number,
        MonthlyRent?: Number,
        Surgery?: Number,
        IncludeMSO?: Boolean,
        IncludeDNA?: Boolean,
        AdditionalPremiumRate?: Number,
        PaymentPeriod?: Number,
        RentPaymentFrequency?: Number,
        RentPayment?: Number,
        PaymentFrequency?: Number,
        PaymentType?: Number,
        ClientStatusID?: Number,
        Indexation?: Boolean,
        PaymentInCurrency?: Number,
        PaymentOutCurrency?: Number,
        Comment?: String,
        UserID?: Number,
        AppointmentID?: Number,
        NotificationsAgreement?: Boolean,
        NotificationsAgreement2?: Boolean,
        Verified?: Boolean,
        Verified2?: Boolean,
        Verified3?: Boolean,
        AdditionalInsuranceType?: Number,
        Beneficiaries?: Beneficiaries[],
        HealthQuestionnaire?: HealthQuestionnaire,
        FATCAQuestionnaire?: FATCAQuestionnaire,
        SPNFTForm?: SPNFTQuestionnaire,
        PlatimatikForm?: PLATIMATICQuestionnaire,
        OneTimePayment?: Boolean,
        PaymentPeriodMonths?: Number,
        Interest?: Number,
        CreditAmount?: Number,
        AdditionalIL?: Boolean,
        AdditionalBF?: Boolean,
        AdditionalAS?: Boolean,
        SignedRemotely?: Boolean,
        RedemptionAndCapitalization?: RedemptionAndCapitalizations
    }) { }
}